import GenericListModule from "../../generic-list-module";
import FirstColumn from "../item/first-column";
import React from "react";
import ListItemCell from "../item/cell";
import LastColumn from "../item/last-column";
import GlistActionsCell from "../actions/cell";
import AggregationCell from "./cell";
import {aggregatorFactory} from "../../../../data-structures/aggregators/factory";
import {Aggregators} from "../../../../data-structures/aggregators/types";
import {calculateAggregationValues} from "../../../../data-structures/aggregators/calculate-values";

type Props = {
    className?: string,
    module      : GenericListModule,
    items       : any[]
}

// const debug = "AggregationRow"
const debug = false

export default function AggregationRow(props: Props) {

    const columns = props.module.columns.allVisible();

    const classes = Classes("glist-row", "aggregate", props.className, {
        // 'with-group-by': !!props.module.groupBy,
        // 'is-selected': props.module.selection.isSelected(props.data.id)
    });

    const shellStyles = {
        minWidth: 'calc(100% - {0}px)'.f(props.module.skin.paddingLeft + props.module.skin.paddingRight)
    }

    debug && console.log(debug, 'render', shellStyles)


    const aggregators:Aggregators = {}

    _.forEach(columns, (column)=>{
        if (!column.aggregateFunction) return
        aggregators[column.field.fieldId] = aggregatorFactory(column.aggregateFunction, column.field)
    })

    calculateAggregationValues(aggregators, props.items)


    return (
        <div className={classes}>
            <FirstColumn module={props.module}/>
            {/*{props.module.canDndItems && <div className="dnd-handle-column ui5-icon-dnd"/>}*/}

            <div className="shell" style={shellStyles}>
                {_.map(columns, (column,key)=>{

                    return <AggregationCell module={props.module} aggregator={aggregators[column.field.fieldId]} column={column} key={key} />
                })}

                {props.module.canAddColumns && <div className="add-column"/>}
            </div>
            {props.module.groupBy && <LastColumn module={props.module}/>}
        </div>
    );


}
